// Default breakpoints.
const breakpointValues = {
    breakpoints: [
        "360px", // mobileSm
        "560px", // mobileLg
        "768px", // tabletSm
        "1024px", // tabletLg
        "1366px", // desktopSm
        "1540px", // desktopMd
        "1920px", // desktopLg
        "2560px", // desktopXl
    ] as const,
    labels: [
        "mobileSm",
        "mobileLg",
        "tabletSm",
        "tabletLg",
        "desktopSm",
        "desktopMd",
        "desktopLg",
        "desktopXl",
    ] as const,
};

// See if we can import these from the theme instead.
try {
    import("theme/config/breakpoints").then((themeBreakpoints) => {
        breakpointValues.breakpoints = themeBreakpoints.breakpoints || breakpointValues.breakpoints;
        breakpointValues.labels = themeBreakpoints.labels || breakpointValues.labels;
    });
} catch (e) {
    // Do nothing.
}

export const breakpoints = breakpointValues.breakpoints;
export const labels = breakpointValues.labels;
